<template>
  <v-container fluid class="px-0">
    <validation-observer ref="observer">
      <v-row dense>
        <v-col>
          <TextFieldRef :label="$t('ELE0143')" :value="itemComputed.inspFiltering" />
        </v-col>
        <v-col>
          <TextFieldRef :label="$t('ELE0140')" :value="itemComputed.partInspTimingName" />
        </v-col>
        <v-col>
          <TextFieldRef :label="$t('ELE0144')" right :value="itemComputed.inspBasicQty" />
        </v-col>
      </v-row>
      <v-row dense class="pt-4">
        <v-col>
          <TextFieldRef :label="$t('ELE0145')" :value="itemComputed.inspLevelAqlRate" />
        </v-col>
        <v-col>
          <TextFieldRef :label="$t('ELE0203')" rules="xrfDateExpired" :value="itemComputed.xrfLastDatetime" />
        </v-col>
        <v-col>
          <TextFieldRef :label="$t('ELE0025')" :value="itemComputed.measIns" />
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef.vue'
import { ValidationObserver, extend } from 'vee-validate'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput.vue'

export default {
  name: 'PartsInspInformationForm',

  components: { TextFieldRef, ValidationObserver, TextFieldInput },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    itemComputed: {
      get() {
        return this.item
      },
    },
  },
  async mounted() {
    extend('xrfDateExpired', {
      validate: () => {
        if (this.itemComputed.isXrfExpired) {
          return this.$t('MSG0060', { p0: '{_field_}' })
        }
        return true
      },
    })
    await this.$refs.observer.validate()
  },
}
</script>
